module.exports = __webpack_public_path__ + "img/blpjs01_center_001.a6f574e6.png";